angular.module('TetherApp').factory(
    'pagesService',
    [
        '$http',
        function ($http) {

            let randomString = function randomString(length, chars) {
                let result = '';
                for (let i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
                return result;
            };

            let indexPages = function (page) {
                let uri = '/api/v1/experience/pages/' +
                    randomString(
                        16,
                        '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                    );
                if (page != undefined) {
                    uri += '?page=' + page;
                }
                return $http.get(
                    uri,
                    {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' }
                    }
                )
                    .then(
                        function (response) {
                            return response.data;
                        }
                    );
            };

            let storePages = function (data) {
                return $http.post(
                    '/api/v1/experience/pages',
                    data,   //OBJECT
                    {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' }
                    })
                    .then(
                        function (response) {
                            return response.data;
                        }
                    );
            };

            let updatePages = function (data) {
                let uri = '/api/v1/experience/pages/' + data.experience.eid;
                return $http.put(
                    uri,
                    data,   //OBJECT
                    {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' }
                    }
                )
                    .then(
                        function (response) {
                            return response.data;
                        }
                    );
            };

            let deletePages = function (pagesId) {
                let uri = '/api/v1/experience/pages/' + pagesId + '/' +
                    randomString(
                        16,
                        '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                    );
                return $http.delete(
                    uri,
                    {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' }
                    })
                    .then(
                        function (response) {
                            return response.data;
                        }
                    );
            };

            return {
                indexPages: indexPages,
                storePages: storePages,
                updatePages: updatePages,
                deletePages: deletePages
            }

        }
    ]
);
